import { UNIT } from '../../constants/configuration';

const styles = {
  commonStyle: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #000',
    borderRadius: UNIT
  },
  verticalTerminalStyle: {
    width: UNIT * 3,
    height: UNIT * 3,
    borderRadius: UNIT * 3
  }
};

export default styles;
